/**
 * The open overlays that make the Feedback launcher step aside: a dialog, a
 * sheet, a drawer or an alert dialog. Their primary action sits where the
 * launcher rests, so it moves to the inline start while one is open.
 *
 * A popover is NOT one of them. Radix stamps `role="dialog"` on popover content
 * too, so every filter dropdown, combobox and date picker used to count as a
 * modal: opening a Status filter sent the launcher across the page and closing
 * it sent it back (staging, 21 Oct #1). A popover sits under its own
 * trigger and blocks no corner, so anything rendered inside a Radix popper is
 * left out. A popover opened inside a dialog changes nothing: the dialog
 * itself still counts.
 */
export const BLOCKING_OVERLAY_SELECTOR = [
  '[data-slot="dialog-content"][data-state="open"]',
  '[data-slot="sheet-content"][data-state="open"]',
  '[data-slot="drawer-content"][data-state="open"]',
  '[data-slot="alert-dialog-content"][data-state="open"]',
  '[role="dialog"][data-state="open"]',
].join(", ")

const POPOVER_SELECTOR = '[data-slot="popover-content"], [data-radix-popper-content-wrapper]'

export function countBlockingOverlays(root: ParentNode): number {
  let count = 0
  root.querySelectorAll(BLOCKING_OVERLAY_SELECTOR).forEach((el) => {
    if (!el.closest(POPOVER_SELECTOR)) count += 1
  })
  return count
}
